<template>
  <div class="timeline">
    <b-row>
      <b-col col lg="3">
        <b-row>
          <b-col style="margin-top: 20px; margin-left: 20px">
            <b-row>
              <span class="date">{{ formatDate(data.created_at) }}</span>
            </b-row>
            <b-row>
              <span class="time">{{ formatTime(data.created_at) }}</span>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
      <b-col col lg="9">
        <div class="timeline-data">
          <b-row>
            <b-col class="tmark"><span class="mark">0</span></b-col>
          </b-row>

          <b-row>
            <b-col class="title"
              ><span class="key-label">{{ data.status }}</span></b-col
            >
          </b-row>

          <b-row>
            <b-col class="description"
              ><span class="label">{{ data.description }}</span></b-col
            >
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "Timeline",
  props: { data: null },
  methods: {
    formatDate(date) {
      var months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let d = date.split(" ")[0];
      var sections = d.split("-");
      return (
        sections[2] + " " + months[parseInt(sections[1])] + ", " + sections[0]
      );
    },
    formatTime(date) {
      return date.split(" ")[1];
    },
  },
};
</script>

<style scoped>
@import "../../commons/tables.css";

.timeline {
  width: 400px;
  border-radius: 6px;
  margin-left: 10px;
  margin-right: 10px;
}

.timeline:hover {
  box-shadow: 2px 5px 5px 5px #d8d8d8;
}

.timeline-data {
  padding-top: 5px;
  padding-bottom: 5px;
  border-left: solid 3px #5e5e5e;
}

.title {
  margin-left: 20px;
}

.description {
  margin-left: 20px;
}

.tmark {
  background: transparent;
  margin-left: -12px;
}

.key-label {
  color: #222222;
  font-size: 16px;
  font-weight: bold;
}

.label {
  color: #222222;
  font-size: 12px;
}

.date {
  font-style: italic;
  font-weight: bold;
  color: #222;
  font-size: 14px;
}

.time {
  font-style: italic;
  color: #5e5e5e;
  font-size: 12px;
  line-height: 10px;
}

.mark {
  font-size: 14px;
  background: #9f0012;
  color: #9f0012;
  padding: 2px 7px;
  border-radius: 32px;
  font-weight: bold;
}
</style>
